/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ErrorName from '../../../core/error/error-name';
import { errorWithName } from '../../../core/error/error-with-name';

/**
 * @import { NetworkManager as INetworkManager } from '../../../core/network'
 */

/**
 * Správce připojení k síti pro standardní webové technologie.
 * @implements {INetworkManager}
 */
export default class NetworkManager {
  /** @type {INetworkManager['getAllConnections']} */
  async getAllConnections() {
    // Web neumožňuje zjistit dostupná připojení.
    return await [];
  }

  /** @type {INetworkManager['getProxyServer']} */
  async getProxyServer() {
    throw await errorWithName(
      ErrorName.NotSupportedError,
      'Getting proxy server info is not supported on web platform.'
    );
  }
}
